module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.16.0.0.box.776.746.82.120.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center",
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.16.0.0.box.776.746.82.120.q.60"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.185.1236.1255.1153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.16.1.0.box.185.1236.1255.797.q.60"
    }
  }, [_vm._v("Like a quickening wind, excitement ruffled the crowd gathered on the banks of the Monongahela at Pittsburgh on the twentieth day of October in 1811. It rippled across gossiping clusters of the fashionably dressed—women in spencers of velvet or lute-string and gently falling skirts or in fur-lined tippets over walking dress, men in narrow pantaloons with gaiters or soft leather boots, whose high collars and folded neckcloths gave them a sore-throated look. It passed on to others, less stylishly dressed, who stood a little apart, women in full-skirted dresses and shawls pulled tight against the chill and men in wider pantaloons and jackets of deplorable line. Finally, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _vm._v("skipped over to the red-shirted rivermen in buckskins who stood scowling and spitting tobacco along the river bank, flicking at them until they too stirred beneath its touch.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.187.2055.1248.334.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.1.0"
    }
  }), _vm._v("Latecomers felt the excitement as they hurried along Wood Street or Grant beneath the bordering poplars or turned in from Market Street, sidestepping mud holes and the scavenging pigs that poked at garbage and dead cats. So did those who drifted in from Braddock's Field Road to join the eager procession making its way toward Water Street. For here, in the valley beneath"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.0.0.box.275.193.1253.337.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _vm._v("\nBoyd's Hill, near Suke's Run, lay the shops and yards of the Mississippi Steamboat Navigation Company; and here, on this bright Sunday morning, one could view the departure of Mr. Nicholas Roosevelt's steamboat, the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans, ")]), _vm._v("first to challenge the dangerous western waters, on her maiden—some said her one and only—voyage.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.0.0.box.275.193.1254.2188.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.1.box.276.544.1253.628.q.60"
    }
  }, [_vm._v("Voices rose and fell along the riverbank and up the hill; here and there was laughter, and the shrill shouts of children floated on the crisp October air. Spectators craned their necks for a better view of the river, where the blue-hulled steamboat huffed and puffed and blew black smoke like a squat, contemplative dragon. One hundred forty-eight and a half feet long and thirty-two and a half wide, with a molded depth of twelve feet, she loomed large to eyes more used to flats and keelboats and even to giant barges. Her curious paddle wheels poked out on either side, her dark chimney was tall as a manufactory's, and the tapered masts, fore and aft, reached toward a smoke-smudged sky.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.2.box.275.1185.1253.1081.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.2.0"
    }
  }), _vm._v("Not all the attention was on the boat. Heads turned too to watch the pathway leading to the shipyard office, from which twenty-year-old Lydia Roosevelt, eight months pregnant, would soon emerge with her little girl. Some of the voices raised were sharp, incredulous: \"Is she really going?\" \"She did before, didn't she?\" \"Yes, but with the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("child")]), _vm._v("—\" (Some said "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bairn, ")]), _vm._v("and some said "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("daft, ")]), _vm._v("too, in the \"braid Scots\" so much heard in Pittsburgh.) It was clear from the comments exchanged that many of those who were there were dubious about the propriety of Mrs. Roosevelt's presence aboard the vessel, dubious too about her husband's good judgment and even his sense of decency. For a year and a half, though, the boat-loving people of Pittsburgh had watched the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _vm._v("a-building, and most of them felt that both the boat and the Roosevelts, Easterners though they were, deserved a fine farewell. Especially fine, considering that once they made their perilous way downriver (if they actually did), the boat at least would never return. She was scheduled to ply as a packet between her namesake city and Natchez, whence goods could travel upriver by keelboat or over the Natchez Trace.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.3.box.275.2278.1252.103.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.3.0"
    }
  }), _vm._v("There were some sorrowful faces in the crowd. The Roose-velts had become a part of the community during their lengthy"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.0.0.box.241.194.1252.1501.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _vm._v("\nstay, and there were those among the spectators, wise in the rivers' ways, who saw trouble ahead. Reaching Louisville, with its shallow, treacherous falls, where a deep-hulled vessel could wait months for a rise, would be the easy part; if the rapids were successfully passed—a big "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("if-")]), _vm._v("—there lay between the scattered settlements along the Ohio long stretches of forbidding wilderness. Within them lurked remnants of murderous pirate gangs and vicious boat wreckers. Indians in the region, relatively quiet for a generation, were being newly stirred to anger by the calls for war of Tecumseh, chief of the Shawnees, who sought to unite tribes north and south in a great confederacy. His passionate eloquence, supported by the awe his followers felt for his brother, called the Prophet, threatened the interior lands with a bloody and terrible war. Below the Ohio, along the Mississippi, where the unsettled shores extended for hundreds of miles and Indian tribes still held formal possession of much of the land, the dangers would be greater still; and little help could be looked for from settlers along the way. Only New Madrid on the western side and Natchez on the east were more than tiny villages; and settlers occupying the old Spanish land grants to the west in what was now Louisiana Territory were few and widely scattered. They were not generally sympathetic to \"Americans\" either, even though, since the Purchase eight years earlier, that was what they themselves were supposed to be (to the distress of Easterners, who saw in the Purchase not only extravagant folly but a charter for mischief against the established states).")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.0.0.box.241.194.1252.2192.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.1.box.243.1709.1250.620.q.60"
    }
  }, [_vm._v("Then, as if man-made dangers were not enough, there lay in wait for rash mortals the \"wicked river\" itself, with its snags and bars and deadly ripples, a hostile, elemental force, jealous and vengeful, its allies the wind and the sky and the very earth. To float submissively along on its shifting currents by flatboat or keelboat was one thing, a venture that offered no defiance to stir the river's wrath, or to push laboriously upward month after month, paying appropriate tribute in muscle and skill and a measure of fear, but to challenge the Mississippi in an impudent, untried boat with a roaring boiler sure to explode and paddles flapping along the sides was the act of a fool—and a fool's wife.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.2.box.343.2339.1146.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _vm._v("Lydia Roosevelt had n"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.16.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.17.0.0"
    }
  }), _vm._v("o more sense than her"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.22.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.25.0.0"
    }
  }), _vm._v(" husband,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.0.0.box.253.198.1254.620.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.26.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.28.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.30.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.31.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.32.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.33.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.34.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.35.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.36.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.37.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.37.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.38.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.39.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.40.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.41.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.42.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.15.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.21.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.25.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.31.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.32.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.33.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.34.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.35.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.36.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.37.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.38.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.39.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.40.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.41.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.42.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.43.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.44.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.45.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.46.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.47.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.47.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.48.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.49.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.50.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.51.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.52.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.53.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.54.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.55.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.56.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.57.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.58.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.59.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.60.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.60.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.61.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.62.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.63.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.64.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.65.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.66.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.67.0.0"
    }
  }), _vm._v("\neveryone said, despi"), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _vm._v("te her being the eldest daughter of the distinguished architect Benjamin Latrobe, surveyor general of the United States, whom one would expect to have some influence on her. One would expect it, that is, who did not know how little influence he had had in trying to stop her marriage to a man more than twice her age and—New York Roosevelt or not—an evidently improvident one as well. Nor had he been able to dissuade her from going along on that impossible flatboat voyage two years ago, in 1809, a voyage that she and her husband called a belated honeymoon but that most sensible people agreed only showed her willfulness.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.19.0.0.box.128.230.1557.1955.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0009.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.3.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.0.0.box.43.358.1604.1745.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0010.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.0.0.box.249.198.1261.2194.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.0.1.box.251.841.1259.1203.q.60"
    }
  }, [_vm._v("It was a survey voyage assigned to Roosevelt by his partners, Messrs. Fulton and Livingston. On it they were to base their decision about the feasibility of building a steamboat for the western waters. One could hardly believe that either Robert Livingston, former chancellor of New York and minister to France, or Robert Fulton, whose "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("North ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("River ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Steamboat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Clermont ")]), _vm._v("was even now marvelously plying the Hudson River, expected him to take his bride along and make a six-months' sightseeing voyage of the assignment, not to speak of spending their money to open coal mines along the way for fuel for a boat that had yet to be built. Roosevelt had a reputation for getting into financial trouble by just such impetuous ways, always blithely assuming that somebody else would pick up the tab. A splendid maker of steam engines but notorious for financial failures and currently in debt up to his ears, he had been taken in as a third partner in the Pittsburgh venture at the behest of Mr. Latrobe, who was friendly with Fulton and hoped the project would bring good fortune not only for Roosevelt's sake and his daughter's, but also for his own. He had unwisely endorsed a number of Roosevelt's notes, still unpaid, when Roosevelt had been his friend and partner but not yet his son-in-law.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.0.2.box.249.2057.1254.335.q.60"
    }
  }, [_vm._v("Few people in Pittsburgh, though, knew much about the marriage or how it came about. Few of them even knew the Latrobes or the Roosevelts, Easterners all, but they did know about the flatboat voyage, for it was in Pittsburgh that it began. And used as they were in this frontier town to the unconventional, Lydia Roosevelt had managed to shock even them.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.0.0.box.177.211.1256.2191.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.0.0.box.178.211.1255.1216.q.60"
    }
  }, [_vm._v("They had not yet become prudes, these Westerners—frontier living was too immediate, too close—but even here a defensive reaction to British disdain for American culture and manners was creating an artificial social code. The rising affluence in the cities that was making female idleness possible and the idle wife a symbol of success was promoting an exaggerated ideal of the \"lady,\" and traditional respect for the working woman was disappearing. Even for the frontier wife, the ultimate goal of the arduous struggle for survival was to attain a society in which the struggle would no longer be needed and gentility would prevail. The piano carted laboriously across the mountains, the silk dress dreamed of, the useless ornament treasured were earnest of an easeful, gentle life to come. Especially in proud western towns like Pittsburgh and Cincinnati, decorum among the \"ladies\" was carried to extremes that amused visitors from abroad or from the more sophisticated East. Someone like Lydia Roosevelt, daughter of a distinguished family, stepdaughter of lovely Mary Hazle-hurst Latrobe, who was Dolley Madison's dear friend, and wife of a man whose family name was known even in Pittsburgh, was expected to keep the lady image bright. To do less was to betray not only her sex but her country too.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.0.1.box.177.1441.1255.739.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.1.0"
    }
  }), _vm._v("She'd not cared at all. Not only had she insisted on going along on the flatboat trip like an ordinary frontier woman (taking a maid along, however); not only had the voyage lasted six months; not only had she and her husband slept often in the open with all the crew about; not only did she herself, when fever struck everyone else aboard, clean and cook and nurse the sick (including the filthy hired hands) for three whole weeks, once bailing out the boat from nine in the evening until one in the morning—that was not all. No, the most shocking aspect of the whole voyage was that, during the entire time, Lydia Roosevelt was, visibly for the most part, pregnant. She and her husband had barely made it back to New York from New Orleans, on a ship with yellow fever aboard, in time for the baby to be born.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.0.2.box.177.2192.1253.210.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.2.0"
    }
  }), _vm._v("So what could one expect now? What one ought "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rightly ")]), _vm._v("to expect, the matrons of Pittsburgh said to one another—and although the words of most came out as soft expressions of distress, those of some were hurled like stones—was that her husband"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.0.0.box.254.256.1263.1148.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _vm._v("\nwould put his foot down this time. After all, she was in a family way again, and the insistence of the two of them on being together even now was—well, strange. Their husbands, if they knew Mr. Roosevelt well enough, remonstrated delicately with him after a wink and a clap on the back intended to show that they understood how it was to be married to a girl twenty-three years younger (and how was it? they wondered), but the remonstrances were for the most part kindly. Not only were many of those who spoke to him personal friends; they were also aware of what the building of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _vm._v("had meant to Pittsburgh in dollars and cents. The work of construction had called for the services and products of foundries and shops; there were jobs at the boatyard for carpenters and joiners and caulkers; expert mechanics were brought in from the East to work on the construction of the engine; and a number of local enterprises—a rolling mill, forges, a slitting mill, a rope walk, machine shops-—were projected in response to the promise of a whole new industry. Mr. Roosevelt had shown his own confidence in the future of Pittsburgh by investing in a distillery and a snuffbox factory right here in town.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.0.0.box.254.256.1263.2127.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.0.1.box.255.1419.1261.964.q.60"
    }
  }, [_vm._v("Besides, they were an attractive couple, even if at first you might take them for father and daughter. They were welcomed at once into Pittsburgh's small elite, to be entertained by the O'Haras and Nevilles and Rosses, the Bateses and Baldwins and Scotts-—die-hard Federalists and Republicans alike—and to entertain nicely themselves. True, they were not Presbyterians, but one could make allowances for that. They had many local connections. Albert Gallatin, former congressman from western Pennsylvania and now secretary of the treasury, was the Latrobes' neighbor in Washington. Aaron Burr, who had been instrumental in bringing statehood to Tennessee and who was still popular in the West (no one mourned Alexander Hamilton, instigator of the infamous whisky tax), had been for years a close family friend. Here in Pittsburgh, Benjamin Bakewell, whose glass-works was located almost adjacent to the boat"), _c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _vm._v("yard, was the uncle o"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.2.0.0"
    }
  }), _vm._v("f Mrs. Roosevelt'"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.7.0.0"
    }
  }), _vm._v("s Philadelphia friend"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.6.0"
    }
  }), _vm._v(" Lucy Bakewell, who h"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.11.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.13.0.0"
    }
  }), _vm._v("ad married a handsome"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.23.0.0"
    }
  }), _vm._v(" Frenchman named John"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.25.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.2.0"
    }
  }), _vm._v(" James Audubon and"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.0.0.box.277.255.1254.104.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.30.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.31.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _vm._v("\nwas now living in Henderson, Kentucky, where her husband kept a store.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.0.0.box.79.255.1475.2175.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0011.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.3.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.0.0.box.277.255.1258.2128.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.1.box.278.373.1255.628.q.60"
    }
  }, [_vm._v("During those weeks prior to the flatboat trip, therefore, the Roosevelts visited in James Ross's sumptuous Georgian-style home near Aspinwall and at the clapboard homes on Market Street, for which the \"Clapboard Junta,\" a powerful political group of merchants and professional men, was named. They attended concerts of the Apollonian Society and a dramatic performance in which young men played the female roles, and made many new friends. It was natural that after their return the following year from New York with Rosetta Mark Roosevelt, the cause of all the clucking of tongues, they were soon involved in Pittsburgh life.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.2.box.279.1014.1256.1313.q.60"
    }
  }, [_vm._v("Lydia often walked with Rosetta down to the Point, where the Allegheny and the Monongahela meet to form the broad Ohio, there to see the vessels loading and unloading, arriving and departing, and hear the sweet sound of the boathorn as a vessel rounded the bend. She went marketing with her maid on Wednesdays and Saturdays, traveled by hired carriage out to the scenes of the curious rock carvings not far from town (there was only one private carriage in Pittsburgh, Mr. O'Hara's). She looked over the books in Mr. Patterson's new bookstore, and stopped in for mail at the post office where John Scull, the postmaster, printed the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gazette ")]), _vm._v("in a back room of his two-story log house. She learned to lift her skirts in the street and from the floor in any public place and to control her temper when tobacco juice spattered her dress, and to stand aside for the coach from Philadelphia or the huge Conestoga wagons that came rumbling through the streets on their iron-tired wheels, as well as for the pigs and goats that seemed to own the streets—but, then, they did in Washington, too! She kept only river water in the house for drinking, for the spring water was impregnated with coal oil, and she kept a wary eye for dogs with frothing mouths. Not even madstones could save anyone, once bitten, from a horrible death. She learned, too, not to argue politics, not only because politics started sparks flying but also because women here did not.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.3.box.381.2340.1153.43.q.70"
    }
  }, [_vm._v("And she visited the boatyard. She had inspected the cabin"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.0.0.box.177.261.1254.858.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _vm._v("\nspecifications with a designer's eye (had she not designed the flatboat interior? and very well too!) and loved watching the steamboat take shape. She knew that her boatyard visits were sometimes criticized by other women, whose activities rarely encroached on their husbands' domains, and knew that their husbands believed the visits set a bad precedent—a man should have one woman-free place in his life—but in her role as young mother she had gained rapport with the women, and their husbands simply liked her. She was lively and bright and pretty, with a charming way of gesticulating that seemed interestingly French, and older men, who felt awkward initially with this wife of their contemporary who was herself younger than their daughters, soon found themselves at ease. They looked in vain for the defects in Mrs. Roosevelt's features that a few of the wives had pointed out to them.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.0.0.box.177.261.1255.2141.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.1.box.178.1142.1254.1260.q.60"
    }
  }, [_vm._v("Interest in the Roosevelts, however, was more than equalled by interest in the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans. ")]), _vm._v("Pittsburgh was supremely boat-conscious. For a while it had even turned out seagoing ships, but now the building of keelboats and flatboats, barges and packets alone kept the riverfront yards constantly busy. It was to those boatyards that men came who wanted the best, who knew that here was the knowledge of the rivers' demands and the skills to make boats that could meet them. Here, eight years earlier, the boatwatchers watched as Meriwether Lewis's custom-built keel-boat took shape for the great expedition to the West, with its ten-foot decks at bow and stern, its forecastle and cabin and movable breastworks. Here too they watched as barges of all sizes and shapes were made, often of fifty-ton burden or more, designed to carry forty hands besides the patroon, or captain. They saw pass along the Ohio all manner of boats bearing people and things: trading boats, with their calico flags; keelboats heavy with pine planks brought by wagon from New York or with furs from Maine or with Philadelphia flour; broadhorns and ferryflats and Allegheny skiffs; floating grist mills and tobacco boats; showboats; family boats—these last, many of them, homemade and in such wondrous shapes that a traveler wrote for history that one could \"scarcely imagine an abstract form in which a boat can"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.0.0.box.279.255.1254.209.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v("\nbe built, that in some part of the Ohio or Mississippi you will not see, actually in motion.\" But for even the finest, the sleekest of boats, one round trip a year to New Orleans was the best that could be done.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.0.0.box.279.255.1258.2186.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.1.box.279.489.1254.973.q.60"
    }
  }, [_vm._v("This limitation was mightily pleasing to the eastern merchants, who wished no competition from a busy inland trade. As it was, the Westerners were kept comfortably in debt to them by means of nine to twelve months credit terms for products wagoned in from Philadelphia or Baltimore or New York while their own products traveled slowly downriver once a year. The profitable trans-Atlantic trade carried on by eastern merchant fleets often consisted of western products—lumber and flour and whisky—that were carted into eastern ports, bought at low prices, and sold for enormous profit at European ports. The East knew that if those western products, the superior western flour, for instance, that sold in New Orleans for a dollar more than any other, came down the river in greater volume or more speedily, to be shipped on to the West Indies and elsewhere, it could displace what arrived by sea from Baltimore and Philadelphia. It might even, God forbid, travel up the seaboard and create a demand for it where eastern flour had a gratifying monopoly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.2.box.279.1475.1258.679.q.60"
    }
  }, [_vm._v("It was the thought of those eastern merchants that could bring a Westerner's blood to a boil. Western Pennsylvanians felt with a sense of mission that Pittsburgh was appointed to become the Birmingham of America and the Gateway to the West. From the beginning of settlement, there had been no nonsense about religion: the early settlers had come here for economic reasons or to escape the Revolution, and only ministers very recently arrived assailed the notion that business came first. The archenemy of that mission was the breeches-wearing, Federalist-leaning eastern establishment, made up of a combination of Shy locks and greedy merchants determined to keep for themselves not only the balance of trade but the political power that went with it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.3.box.279.2165.1252.276.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.3.0"
    }
  }), _vm._v("\"The old states sink,\" Josiah Quincy of Massachusetts cried angrily as new western lands were opened. What right had Congress to dilute the power of the origi"), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.4.0"
    }
  }), _vm._v("nal thirteen? New Englanders proclaimed the Louisiana Purchase a disaster, unconstitutional and extravagant. Before you knew it, they predicted"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.0.0.box.184.253.1253.340.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  }), _vm._v("\ngloomily, the destiny of the nation would be in the hands of wild men from Missouri and other barbaric lands. If new states were formed from Louisiana Territory, New England, her spokesmen threatened, might well secede, \"amicably if possible, violently if necessary,\" to form with New York an independent nation as was their right under the compact of sovereign states.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.0.0.box.184.253.1254.2189.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.0.1.box.185.609.1253.1261.q.60"
    }
  }, [_vm._v("For their part, western Pennsylvanians in particular saw on every hand the nefarious work of their enemies. Even now, with the first digging for the National Road taking place, there was talk in Congress of establishing its first junction not at Pittsburgh, a natural point of departure for the West, but at Wheeling, which just happened to be in the state of Virginia. A blind man could see the fine hand of Madison in that! The "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gazette ")]), _vm._v("and the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Commonwealth ")]), _vm._v("lamented the tribute paid by their subscribers to the \"Pennsylvania and Maryland waggoners,\" who took only precious specie from the West and none of its produce. They assailed the indifference of Congress to improving the navigation of the western waters and deplored the lack of concern on the seaboard for the Indian menace on the frontier. They denounced Congress for its refusal to recognize that the British, still hoping to salvage some of America's territory, were fanning the flames of savagery. What good would it do western Pennsylvania, they demanded, to boast of its proliferating factories, of its glassworks and sawmills and distilleries, foundries and boatyards, of its superior flour and excellent rye whisky, as long as transportation remained slow and hazardous and the imbalance of imports mortgaged the region to the traders and bankers of Philadelphia, Baltimore, New York, and Boston?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.0.2.box.186.1886.1252.556.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.2.0"
    }
  }), _vm._v("If, though, the rumor ran, this crazy steamboat idea really worked, if a vessel could go downriver at a speed of eight or ten miles an hour—an hour, mind you!—and upstream at three or four, even against the Mississippi, as opposed to the three miles an hour down and (with luck) the mile an hour upstream of a barge, it would revolutionize trade in favor of the West. The Mississippi, that great, wicked river was, as Madison once s"), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.3.0"
    }
  }), _vm._v("aid, \". . . to them [Westerners] everything . . . the Hudson, the Delaware, the Potomac, and all the navigable rivers of the Atlantic States, formed into one stream.\" With steamboats it could"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.0.0.box.276.265.1257.980.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _vm._v("\ncarry three or four times its present burden. Products from factory and farm—surplus salt and beef and flour and apples, guns and cordage and whisky and cotton—would go racing down the Ohio to the big river and on to New Orleans, and from there to the West Indies, to Europe, up the coast to eastern ports, to ports all over the world. Furs from the far Northwest, where John Jacob Astor now had a trading center, would travel down the Missouri more quickly than ever before. With ready access to markets, settlers would move into the interior, land would become more valuable; they would build homes, shops, factories, towns, cities. There would be new states—a region could fill up with the required thirty thousand people in no time, and the West would have other men in Congress like Henry Clay and Albert Gallatin. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Then ")]), _vm._v("the uppity East would get its comeuppance. Maybe the United States of America would start looking westward the way they should; maybe there would even be a real feeling of union. St. Louis might become the national capital.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.0.0.box.273.265.1260.2193.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.0.1.box.275.1258.1255.621.q.60"
    }
  }, [_vm._v("Even before the keel of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _vm._v("was laid, therefore, the yard of the Mississippi Steamboat Navigation Company was a magnet for sightseers. Men would stop by after a day's work was done or stroll with their wives along Water Street on Sunday and climb Boyd's Hill to look down on the scene. Small boys, drawn as flies to honey to the construction site, pestered the workmen and got to know Tiger, the Roosevelts' great Labrador, who came often with his mistress to visit the yard. Visitors from the East asked as often, it seemed, to see \"Mr. Roosevelt's boat\" as they did to visit the glass factories that were Pittsburgh's pride.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.0.2.box.273.1893.1255.565.q.60"
    }
  }, [_vm._v("It was not actually Mr. Roosevelt's boat, and it was reported that the tendency of people to call it his was extremely annoying to his associates, especially Robert Fulton, who designed it. Roosevelt was the least prestigious and certainly the poorest of the partners, but here he was the most visible. It was fortunate for the success of the project that he was, for Messrs. Fulton and Livingston were anything but popular in the region. They had tried to obtain from the states along the way the sa"), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.3.0"
    }
  }), _vm._v("me monopoly for the western rivers that they held for the Hudson, by which they and they alone would have the right to use steam for navigation"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.0.0.box.170.212.1251.161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _vm._v("\nalong those rivers for twenty years. This in the West!—where whatever bound, held back, suppressed, was and ever would be anathema. The papers shouted outrage:")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.0.0.box.168.212.1254.2185.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    attrs: {
      "id": "para.30.0.1.box.294.407.1002.236.q.60"
    }
  }, [_vm._v("Our road to market must and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _vm._v("be free; this monopolizing disposition of individuals will only arouse the citizens of the West to insist on and obtain recognition of their rights, viz. the privilege of passing and repassing, unmolested, on the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("com")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.2.0"
    }
  }), _vm._v("mon ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("highway ")]), _vm._v("of the West.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.0.2.box.169.676.1253.857.q.60"
    }
  }, [_vm._v("Today, the Mississippi; tomorrow it could be lakes or streams or grazing lands. Only Governor Claiborne of the Territory of Orleans, who was not a Westerner, any more than Orleans was the West, had granted them an eighteen-year monopoly after being wooed with a campaign of wining and dining that included a visit to New York and a ride on the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Clermont. ")]), _vm._v("Besides, the greed of them! No wonder Mr. Roosevelt, well liked as he was, had trouble selling subscriptions to the company. Under the conditions of subscription, the partners would divide ninety percent of the profit, with investors receiving dividends from the leftover ten percent. Mr. Roosevelt himself, as he avowed with most engaging candor, had had no part in drawing up the conditions and could hardly be blamed for what he could not control. Besides, he was investing "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("his ")]), _vm._v("profits locally—in advance of receiving any, it was true; but that he was doing so showed good faith.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.0.3.box.168.1548.1252.792.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.3.0"
    }
  }), _vm._v("Unresponsive as they were to his appeal for investment, therefore, Pittsburgh's citizens had only admiration for Mr. Roosevelt's skill as he went about building the engine and supervising the building of the boat. None knew of the nagging sense of injustice that occasionally beset him. For it was he who had proposed the side paddle wheel design that had made the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cler")]), _c('i', [_vm._v("-mont ")]), _vm._v("a brilliant success and that was now being used for the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans, ")]), _vm._v("a design that had been scoffed at and rejected by Robert Livingston ten years earlier when Roosevelt, employed by him to build a steamboat, had presented the side paddle wheel plan. Later on, or so Roosevelt was convinced, Livingston passed on the side paddle wheel idea to his new found friend and protege Robert Fulton, who knew a good thing when he saw it and was now reaping the fruits of its execution in glory and wealth.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.0.4.box.268.2352.1145.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.4.0"
    }
  }), _vm._v("Moreover, the building of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _vm._v("went badly."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.0.0.box.275.206.1254.511.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _vm._v("\nFrom the beginning, everything seemed to conspire against its completion. Skeptics were not surprised and the superstitious said that an evil star hung over it already, perhaps the very comet that had appeared so spectacularly in the western sky and that the worldly in their foolishness said had no significance. Already called the Great Comet of 1811, it had streaked into the heavens in March, when the boat was ready for launching, and was visible still, even across the sea. Could anyone think such signs were sent without some purpose?")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.0.0.box.269.206.1263.2184.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.0.1.box.269.729.1261.904.q.60"
    }
  }, [_vm._v("l The boat did seem cursed. To obtain oak for planking was impossible without intolerable delay; white pine had to do, and even that was hard to find. Many splendid old trees in the nearby lowlands had been cut down and shipped downriver as shingles or boards or to be used as masts, and to locate trees of the needed girth and shape and height in the trackless forests was a long and tortuous task. Clearing the chosen area, felling the trees, cutting a path for carting them down to the waiting rafts on the river called for more men, more hours, more pay than the partners had counted on, and Roosevelt's accounts went quickly awry, especially when he increased on his own the boat's dimensions. Available saw pits were old and hardly adequate, and a new one had to be built, as did workshops for joiners and filers and smiths; for lack of a rolling mill in Pittsburgh (one would be built the following year), the boiler plates had to be brought in by ox cart from the East.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.0.2.box.278.1654.1253.448.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.2.0"
    }
  }), _vm._v("There were local boatbuilders aplenty, had been since the turn of the century, when Tarascon, Berthoud, and Company had lured from the East skilled workmen—ship carpenters, joiners, caulkers, riggers—with the promise of higher wages (and how "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _vm._v("grievance festered in eastern hearts!). However, Roosevelt did import skilled machinists, which was in itself a slap at local pride; when East and West met there were a few sharp words and occasionally fists flew.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.0.3.box.279.2114.1253.276.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.3.0"
    }
  }), _vm._v("And then—! Work had hardly begun when the Monongahela rose, not once but several times. On Sunday, November 11, 1810, in a day and a night the water rose on "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("both ")]), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.4.0"
    }
  }), _vm._v("rivers thirty-seven feet above the common level. The freshet of that date carried off the public wharf on the Allegheny, came within eight"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.0.0.box.180.262.1252.868.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _vm._v("\nfeet of Market Street, and ascended Wood Street gutters to Front Street. Penn and Liberty were inundated, and at the boatyard great floods of muddy water came pouring in. All buoyant materials—planks lying in the open for weathering, shaped wood being pruned and puttied and sanded and caulked, scraps of lumber, boxes and barrels and chips—went bobbing about, to the delight of the boys who came sloshing through the water to watch and to the frustration of salvaging crews. During the following months the Monongahela itself rose, again and again as though the great and jealous river to the west had sent word. And when, after all the delays, the hull was nearing completion, a sudden rise almost lifted it from the ways and threatened to launch it prematurely on the swollen stream. It seemed only to be expected that when the boat was finally ready the river was not; months were idled away waiting for the autumn rise.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.0.0.box.177.262.1255.2201.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.0.1.box.178.1142.1254.916.q.60"
    }
  }, [_vm._v("From all sides, Lydia and Nicholas Roosevelt heard the clucking of tongues and expressions of sympathy, sincere or feigned. It did seem a warning, didn't it? Why couldn't the boat return a profit just making the run to Cincinnati? To Louisville? Did they really expect to take the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _vm._v("over the shallow Falls of the Ohio, at Louisville? Most urgently, why go on that hazardous twenty-five-hundred-mile voyage themselves? There were men paid to take such risks. What had Mr. Roosevelt to gain? Perhaps nothing at all, the rumor went. Pittsburgh businessmen heard from reliable sources that Fulton and Livingston were considering voting him out of his share of the profits because of his continued extravagance. In the shipyard office, clerks who had seen angry letters coming in whispered that Mr. Roosevelt's snuffbox factory and distillery might not have been bought with his own money after all; if they were, they would soon go to pay his debts.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.0.2.box.177.2072.1252.391.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.2.0"
    }
  }), _vm._v("There were other letters that the people of Pittsburgh knew nothing about. Between Lydia and her father had passed a bitter exchange. Latrobe, long exasperated by his son-in-law's disregard for the difficulties he made for everyone else, and feeling personally to blame for Fulton's troubles with him, wrote to his daughter, whose judgment he respected (\"I wish Lydia were the husband!\" he once exclaimed to her brother), urging her to per"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.0.0.box.267.266.1252.864.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _vm._v("suade her husband to mend his ways. The letter was little more than a long critical recounting of Roosevelt's financial dealings and a number of comments upon his reputation as a speculator. Lydia wrote back angrily. Why did her father consent to her marriage, she demanded, if her husband was so devoid of \"honor, shame, or feeling\"? Why was it that Mr. Fulton could make him believe anything he wanted to about Nicholas? Why couldn't he be "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fair? ")]), _vm._v("Lydia was hurt—she loved her father—but about her husband she was fiercely defensive. Nobody, not even Papa, was to criticize him! And to the gossipmongers and the concerned friends in town she responded with a scornful laugh. Ridiculous! she said, when she heard the story of the partners' threat. Why, the profits to come would more than compensate for expenses and would make all the partners rich, once the boat was put into her planned regular run between Natchez and New Orleans.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.0.0.box.267.266.1254.2134.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.0.1.box.268.1144.1252.796.q.60"
    }
  }, [_vm._v("Once it was—there was the catch. It was strange, murmured the skeptics to one another as they stood beneath the sycamores and looked out toward the blue-hulled vessel that lay puffing away at anchor in midstream, that Fulton and Livingston were not going along. Evidently they felt much as did the people of Pittsburgh, who had left unanswered the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gazette's ")]), _vm._v("advertisement soliciting passengers. \"Elegant cabin\" indeed. What good would that elegant cabin do at the bottom of the river? Or when the boiler exploded and those \"unsurpassed accommodations\" went up in flames? Another thing, commented a few of the more devout, no good would come of violating the Sabbath by departing this day, even to catch the flood. It was tempting the Lord. Were there not signs enough already that He had tired of man's effrontery? The rivermen were telling dark tales.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.0.2.box.270.1950.1251.450.q.60"
    }
  }, [_vm._v("It had been a year of omens, a year that would be remembered forever as the Annus Mirabilis of the West. During the earlier months, the great rivers overflowed, and in the wide valley of the Mississippi, from the Missouri to the Gulf, restless waters surged across the banks. Swirling and grumbling, they shouldered their way into low-lying woods, tore at t"), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.3.0"
    }
  }), _vm._v("he roots of trees, tumbled them into the stream to make great snags and sawyers for waylaying river boats, clawed relentlessly at the undersides"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.0.box.179.1181.1254.219.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  }), _vm._v("\nof bluffs to form watery caves. From shallow graves along the shore they washed up the bodies of hastily buried rivermen and rolled them mockingly into murky depths where others like them lay, grim toll of passage on the hungry river.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.34.0.0.box.174.71.1538.998.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0012.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.1.0.box.179.1181.1254.1201.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.1.box.180.1413.1253.219.q.60"
    }
  }, [_vm._v("In the wake of the brown flood, a plague of sickness walked, bringing fever and the deadly flux, and a cruel rash that leaped from settlement to settlement like a flaming visitation. Children sickened, died. Grief hung in the valley like a mist.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.2.box.180.1645.1253.449.q.60"
    }
  }, [_vm._v("Nature itself seemed warped. In the upper valley, it was reported, squirrels gathered by the thousands, by the tens of thousands, answering some mysterious summons. In a solid phalanx they hurried southward, the sound of their chattering so immense that those who heard it stared at one another, unbelieving. By the thousands they perished in the broad Ohio that lay in their path, their rotting carcasses rolling with the stream; the survivors came to rest only when they could go no more.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.3.box.181.2106.1252.276.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.3.0"
    }
  }), _vm._v("And then, as if a mighty finger marked that dreadful year, the comet came, splitting the night sky. Its forked and fiery tail seemed an instrument of judgment on which the world would be impaled. Night after night it shed its ghostly light over the forest, turning the velvet dark to a silken gloom. The Shawnees"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.0.0.box.279.193.1259.452.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _vm._v("\nand Chickasaws and Creeks, already restive with the war cries of Tecumseh and his brother the Prophet, which for many months had echoed down the valley, stirred uneasily, fingering their guns. Little wonder that settlers along the river, disoriented, their homes awash and boats aground, spoke in whispers of apocalypse. Crowding into camp meetings called by wandering preachers, they were whipped into frenzy and the inexplicable \"jerks\" by soaring voices of doom.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.0.0.box.277.193.1261.2190.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.0.1.box.277.659.1260.1724.q.60"
    }
  }, [_vm._v("But most of Pittsburgh was not devout, and rivermen told tall tales. Moreover, they could well have their own sinister purposes in discouraging the Roosevelts from setting out. To them, sailors of the inland waters, supreme in their domain, the steamboat was an affront. The presumption that steam could do as well as they on the big rivers, or better, derogated their skills, diminished them. The boat would likely fail-—everybody knew that. But if, just if, she didn't, then what would become of keelers, of bargers, of the whole wide world, in fact, as man had known it since his first timid ventures upon the waters of the earth? Now the rivermen were indispensable: Vicious as was their reputation, feared as they were in settlements, where their rowdy visits brought bloody rioting, ugly as were the rivalries that left their mark in gouged-out eyes, in bitten-off ears or lips, they could not be spared, and they knew their worth. Responsible for the transportation of cargo and passengers along all the inland waterways, from the forestbound streams of the vast Canadian fur lands to New Orleans itself, they were expected to be ready to row when rowing was needed or to hoist the sails to a breeze; to move quickly and skillfully to avoid boils and eddies and deadly whirlpools and riffles; to carry towlines in hands or teeth to a sometimes hostile shore and haul the boat forward hand over hand; to back the boat, sometimes a hundred feet long or more, away from snags—the deadly planters, tall trees caught firmly by their roots in the bottom of the river, their tops sometimes invisible, and the sawyers, floating trees that moved up and down, up and down with the current and lunged viciously toward unwary vessels. Rivermen had also to be ready to chop a passage through jams of logs and driftwood; to pole up rapids; to warp when necessary, using the towline in reverse; to bush"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.0.0.box.178.202.1253.389.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _vm._v("whack when the river was high, pulling the boat along by grasping the branches of trees along the shore. And to shoot. Boat owners who sought passenger trade included among their inducements not only bulletproof cabins against the hazards of river pirates and Indians but sharpshooters to man them as well. The rivermen filled that role. And now, to have their skills disdained—?")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.0.0.box.177.202.1254.2198.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.0.1.box.177.615.1254.1268.q.60"
    }
  }, [_vm._v("Why should they not be standing there scowling, apart from the restless, gossiping crowd on the river's shore? Those Kaintucks, masters of the setting poles, the Creoles, famed far and wide as oarsmen, all the red-shirted band that dared the wrath of the river and paid its price? True, six of their peers had been hired as hands for the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans")]), _vm._v("— for such exciting duty as stoking fires!—but whether these watchers thought them fools or traitors or lucky men no one dared ask. The other spectators had their own opinions. Most of them considered the crew as well as the pilot and the engineer hardly less foolhardy than the Roo-sevelts themselves. And nobody could imagine how the two female servants and the waiter and the cook had been persuaded to go along, high wages or not. Perhaps it was their very lack of river experience that made them unafraid. Just fifteen people on a vessel designed with its spacious gentlemen's cabin and ample deck space, for seventy-five! The numbers told you there were not as many fools around as people thought. But if Mr. Roosevelt was ready to risk his life and his family's, too, why, who should quibble so long as the risks were not his own? The venture just might succeed, and if it did, the West would soon be trimming the sails of those eastern merchants, with their monopoly on trade. So ran the conversation on the shore that day.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.0.2.box.177.1897.1253.503.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.2.0"
    }
  }), _vm._v("Besides, just being there put one in a holiday mood. The Sunday clothes of the spectators were as bright as the reds and yellows of the autumn leaves that skipped and skittered down Boyd's Hill and along the riverbank. The southeast wind that teased them and promised more rain to swell the rivers—already most of the waiting flatboats at the Point had left, taking advantage of the flood—blew playfully too at the billowing black smoke and the sparks from the steamboat and pushed them toward town, where waste from cannon stoves and open grates, dis"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.0.0.box.284.264.1252.572.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _vm._v("charging into the streets, was drifting up to meet them. Across the turbid waters of the Monongahela, curling columns of smoke rose from Coal Hill, feeding the sullen pall that hung unendingly over the factories and coal pits to be turned by every errant town-ward breeze into a drizzle of soot that blackened roofs, seeped into shops and markets and churches, and darkened still more the once-white courthouse steeple that now appeared like an etching in charcoal against a hazy sky. Already Pittsburgh was the town where housewives cried to see their dirty curtains, and the snow was gray before it touched the ground.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.0.0.box.277.264.1259.2134.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.0.1.box.277.852.1256.1546.q.60"
    }
  }, [_vm._v("But even the housewives saw silver in the sooty dust and gold in the snow. Pittsburgh was brimming with life, burgeoning, bursting at the seams. You could hear the sound of its growing in the rattle of immigrants' wagons on their way to the West, to Ohio, Kentucky, and Tennessee; in the bustle of shops supplying their needs and in the hawkers' cries in the streets; in the shouts of wagoners arriving with freight from Philadelphia in their red, white, and blue Conestogas, bells jingling as they rolled into town; in the gallop of hooves along cobblestoned streets and the accompanying cries of \"Twenty-five dollars!\" \"Twenty-five dollars, fifty cents!\" as a horse was auctioned on the run. You could hear it too in the hammer and whine and the roar of the factories and in the clink of the busy presses in Zadoc Cramer's printing shop or in the office of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pittsburgh ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gazette ")]), _vm._v("or in the babble of voices in the Diamond, the public square. The sound of the growing was unmistakable down at the Point, in the bump of barrels on cargo decks and the splash of oars; in the shouts of roistering keelers and the merry notes of the fiddle no boat would be without; in the lowing of cattle, the crowing of cocks, and the laughter and crying of children as family boats were loaded for the long float down the Ohio to Limestone and places beyond. And now it was loud in a brazen note new on the river, the triumphant roar of escaping steam, a sound that traveled on the wind toward the western waters, where before had been only the swish of oars and the hallooing voice of the boatman and the haunting call of his horn. And accompanying it, the throb of laboring pistons, like the beat of a nation's pulse.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-939a2dfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0013.vue
// module id = 60
// module chunks = 0